import { useEffect, useRef } from 'react';
import { MobileStates, WidgetStateChangeType, WidgetStates } from '../WidgetLarge/Widget';
import { getAutoExpandTiming, getInitialState, getTargetStateParams } from './Params';
import { getURLParamValue } from '../../clearstep/util/AppHelpers';
export var useWidgetInitialState = function (_a) {
    var mobileState = _a.mobileState, setWidgetState = _a.setWidgetState, userHasInteracted = _a.userHasInteracted;
    /*
      initialWidgetStateDetermined ensures we only do this 1x, but we can't use
      a traditional [] useEffect because we want to run this after the mobile
      state is determined
    */
    var initialWidgetStateDetermined = useRef(false);
    useEffect(function () {
        if (!initialWidgetStateDetermined.current) {
            var initialState = getInitialState(mobileState);
            if (initialState === WidgetStates.HIDDEN) {
                // Default initial state is HIDDEN, so we can exit
                initialWidgetStateDetermined.current = true;
                return;
            }
            if (mobileState === MobileStates.MOBILE &&
                !getURLParamValue('widgetTargetState') &&
                !getURLParamValue('widgetTargetState-m') &&
                !getURLParamValue('widgetInitialState-m') &&
                !getURLParamValue('widgetInitialState')) {
                // Previous requirement to set widget state to COLLAPSED after 5s on mobile,
                // But Corewell wants a new expansion sequence, which they will use the new
                // widgetTargetState-m params to define.
                // Leaving this to allow Corewell to update TODO: we should remove once they've
                // converted to the new params
                setTimeout(function () {
                    /* No auto expansion if user has already interacted */
                    if (!userHasInteracted.current) {
                        setWidgetState(WidgetStates.COLLAPSED, WidgetStateChangeType.SET_DEFAULT_STATE);
                    }
                }, 5000);
                initialWidgetStateDetermined.current = true;
            }
            else if (mobileState !== MobileStates.UNKNOWN) {
                setWidgetState(initialState, WidgetStateChangeType.SET_DEFAULT_STATE);
                initialWidgetStateDetermined.current = true;
            }
        }
    }, [mobileState, setWidgetState, userHasInteracted]);
};
// Setup automatic expansion/collapse sequencing
export var useAutoExpandCollapseSequence = function (_a) {
    var mobileState = _a.mobileState, setWidgetState = _a.setWidgetState, userHasInteracted = _a.userHasInteracted, widgetState = _a.widgetState;
    // Mobile state is asynchronous and set from a resize script, so we can't run this on load.
    // We also want to make sure we don't run this logic twice, so we use a ref to track it.
    var hasRun = useRef(false);
    useEffect(function () {
        if (!hasRun.current && mobileState !== MobileStates.UNKNOWN) {
            hasRun.current = true;
            // Use widgetTargetState(-m) parameters if available to determine
            // auto expand/collapse sequence.
            var targetStateParams = getTargetStateParams(mobileState);
            if (targetStateParams.length > 0) {
                targetStateParams.forEach(function (param) {
                    var targetState = param.targetState, targetDelay = param.targetDelay;
                    setTimeout(function () {
                        if (!userHasInteracted.current) {
                            setWidgetState(targetState, WidgetStateChangeType.AUTO);
                        }
                    }, targetDelay);
                });
                return;
            }
            // Auto-expand widget after 10s if no interaction (Desktop Only) from
            // old requirement. Clients should use widgetTargetState parameters
            // to define expansion sequences going forward. Only run this if
            // widgetTargetState parameter isn't present, to allow Corewell time to update.
            // TODO: Remove once Corewell has converted to widgetTargetState parameters.
            // (potentially if we want to leave the default - move this into a default
            // return from getTargetStateParams)
            var timing = getAutoExpandTiming(mobileState);
            if (timing && timing >= 0) {
                setTimeout(function () {
                    if (mobileState === MobileStates.DESKTOP &&
                        userHasInteracted.current === false &&
                        widgetState !== WidgetStates.EXPANDED) {
                        setWidgetState(WidgetStates.EXPANDED, WidgetStateChangeType.AUTO);
                    }
                }, timing);
            }
        }
    }, [mobileState, setWidgetState, userHasInteracted, widgetState]);
};
